import { SiteSearch } from './site-search.js';
import { ResourceSearch } from './resources-search.js';
import { WebinarSearch } from './webinar-search.js';

export default function initSearch() {
	const siteSearch = new SiteSearch();
	siteSearch.init();

	const resourceSearch = new ResourceSearch();
	resourceSearch.init();

	const webinarSearch = new WebinarSearch();
	webinarSearch.init();
}
